import IllustrationHosting from "../assets/websiteHosting.svg";
import IllustrationWordpress from "../assets/wordpress.svg";
import IllustrationShop from "../assets/shop.svg";
import IllustrationOwnTouch from "../assets/ownTouch.svg";
import IllustrationSecurity from "../assets/security.svg";
import IllustrationUberall from "../assets/uberall.svg";
import IllustrationMarketGoo from "../assets/marketGoo.svg";
import IllustrationEmailUnlimited from "../assets/emailUnlimited.svg";
import IllustrationDns from "../assets/dns.svg";
import IllustrationExchangeOnline from "../assets/exchange_online.svg";
import IllustrationExchangeBasicAndStandard from "../assets/exchange_basic_and_standard.svg";
import IllustrationPlesk from "../assets/plesk.svg";
import IllustrationVPS from "../assets/vps.svg";
import IllustrationManagedVPS from "../assets/managed_vps.svg";
import VPSWindows from "../assets/vpsWindows.svg";
import VPSBackupBasic from "../assets/vpsBackupBasic.svg";

const getProductIcon = (productId) => {
  const productIcon = {
    DOMAIN: IllustrationHosting,
    PPS_EMAIL: IllustrationHosting,
    PPS_SMALL: IllustrationHosting,
    PPS_MEDIUM: IllustrationHosting,
    PPS_LARGE: IllustrationHosting,
    PPS_XXLARGE: IllustrationHosting,
    PPS_WEBSHOP: IllustrationHosting,
    WEBSITE_BUILDER_PREMIUM: IllustrationOwnTouch,
    WEBSITE_BUILDER_ECOMMERCE: IllustrationShop,
    SITELOCK_LITE: IllustrationSecurity,
    MARKETGOO_START: IllustrationMarketGoo,
    UBERALL: IllustrationUberall,
    WORDPRESS_MANAGED: IllustrationWordpress,
    DNS_ADMIN: IllustrationDns,
    MAIL_STORAGE_UNLIMITED: IllustrationEmailUnlimited,
    EXCHANGE_ONLINE: IllustrationExchangeOnline,
    EXCHANGE_M365_BUSINESS_BASIC: IllustrationExchangeBasicAndStandard,
    EXCHANGE_M365_BUSINESS_STANDARD: IllustrationExchangeBasicAndStandard,
    ONEVPS_SMALL: IllustrationVPS,
    ONEVPS_MEDIUM: IllustrationVPS,
    ONEVPS_LARGE: IllustrationVPS,
    ONEVPS_XLARGE: IllustrationVPS,
    ONEVPS_XXLARGE: IllustrationVPS,
    MANAGED_ONEVPS_SMALL: IllustrationManagedVPS,
    MANAGED_ONEVPS_MEDIUM: IllustrationManagedVPS,
    MANAGED_ONEVPS_LARGE: IllustrationManagedVPS,
    MANAGED_ONEVPS_XLARGE: IllustrationManagedVPS,
    MANAGED_ONEVPS_XXLARGE: IllustrationManagedVPS,

    ONEVPS_PLESK_ADMIN_LICENSE: IllustrationPlesk,
    ONEVPS_PLESK_PRO_LICENSE: IllustrationPlesk,
    ONEVPS_PLESK_HOST_LICENSE: IllustrationPlesk,
    ONEVPS_WINDOWS_LICENSE_SMALL: VPSWindows,
    ONEVPS_WINDOWS_LICENSE_MEDIUM: VPSWindows,
    ONEVPS_WINDOWS_LICENSE_LARGE: VPSWindows,
    ONEVPS_WINDOWS_LICENSE_XXLARGE: VPSWindows,
    ONEVPS_WINDOWS_LICENSE_XLARGE: VPSWindows,
    ONEVPS_BASIC_BACKUP: VPSBackupBasic,
    WSB_MINI: IllustrationOwnTouch,
    WSB_BUSINESS: IllustrationOwnTouch,
    WSB_PRO: IllustrationOwnTouch,
    WSB_ECOMMERCE: IllustrationOwnTouch,
  }[productId];

  const isDevelopmentEnvironment = process.env.NODE_ENV === "development";

  if (!productIcon && isDevelopmentEnvironment) {
    console.warn(
      [
        `WARNING: No product icon was configured for product ID "${productId}"!`,
        "(This warning is only shown in development, not in production)",
      ].join(" "),
    );
  }

  return productIcon;
};

export default getProductIcon;
